export const LISTING_LAYOUT_LIST: number = 0;
export const LISTING_LAYOUT_DETAIL: number = 1;
export const LISTING_LAYOUT_MAP: number = 2;

export type ZIDXAdvancedQueryResult = Record<string, string[]>;

export function firstLetterCaps(s: string): string {
    if(s.length==0) return s;
    return s.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
}

export class ZIDXListingSummary {
    type: string = "";
    id: string = "";
    indexId: number = 0;
    uniqueId: number = 0;
    price: number = 0;
    latitude: number = 0;
    longitude: number = 0;
    bedrooms: number = 0;
    bathrooms: number = 0;
    halfBaths: number = 0;
    sqft: number = 0;
    acreage: number = 0;
    address: string = "";
    address2: string = "";
    city: string = "";
    state: string = "";
    postalCode: string = "";
    status: string = "";
    listStatus: string = "";
    photo: string = "";
    createdDatetime: number = 0;

    fixCase() {
        this.id = this.id.toUpperCase();
        this.address = firstLetterCaps(this.address);
        this.postalCode = this.postalCode.toUpperCase();
    }
}

export class ZIDXListingData {
    listings: ZIDXListingSummary[] = [];
    totalListings: number = 0;
    perPage: number = 12;
    // get center
    averageLatitude: number = 0;
    averageLongitude: number = 0;
    locationCount: number = 0;
    minLatitude: number = 0;
    maxLatitude: number = 0;
    minLongitude: number = 0;
    maxLongitude: number = 0;
    forceZoom: number = 0;
}

export interface ZIDXSearchCount {
    count: number;
    offset: number;

    [index: string]: any;
}

export class ZIDXSearchFields {
    zidx_search_price_from: number = 0;
    zidx_search_price_to: number = 2000000000;
    zidx_search_bedrooms_from: number = 0;
    zidx_search_bedrooms_to: number = 100;
    zidx_search_bathrooms_from: number = 0;
    zidx_search_bathrooms_to: number = 100;
    zidx_search_sqft_from: number = 0;
    zidx_search_sqft_to: number = 1000000000;
    zidx_search_acreage_from: number = 0;
    zidx_search_acreage_to: number = 1000000000;
    zidx_search_year_built_from: number = 0;
    zidx_search_year_built_to: number = 2100000000;
    zidx_search_timestamp_from: number = 0;
    zidx_search_timestamp_to: number = 2100000000;
    zidx_search_sort: number = 1;
    zidx_offset: number = 0;
    zidx_search_list_status: string = "";
    zidx_search_type: string = "";
    zidx_search_sub_type: string = "";
    zidx_search_county: string = "";
    zidx_search_parking: string = "";
    zidx_search_frontage: string = "";
    zidx_search_style: string = "";
    zidx_search_view: string = "";
    zidx_search_status: string = "";
    zidx_search_condition: string = "";
    zidx_search_pool: string = "";
    zidx_search_building: string = "";
    zidx_layout: number = LISTING_LAYOUT_LIST;
    zidx_search_city: string = "";
    zidx_search_latitude: string = "";
    zidx_search_longitude: string = "";
    zidx_search_location: string = "";
    zidx_search_listing_table_id: string = "";
    zidx_search_listing_id: string = "";
    zidx_search_polygon: string = "";
    zidx_search_address: string = "";
    zidx_search_open_houses: number = 0;
    zidx_search_subdivision: string = "";
    zidx_search_postal_code: string = "";
    zidx_search_show_listings: string = "0";
    zidx_search_remarks: string = "";
    zidx_search_exclude_remarks: string = "";
    zidx_search_agent_name: string = "";
    zidx_search_office_name: string = "";
    zidx_nearlocation_address: string = "";
    zidx_nearlocation_latitude: number = 0;
    zidx_nearlocation_longitude: number = 0;
    zidx_nearlocation_distanceInMiles: number=0;
    zidx_search_location_tags: string="";
    zidx_search_location_mode: string="";
    [key: string]: string | number;
}

export let searchIsEmbedded=true;
